module.exports = __webpack_public_path__ + "static/media/default.ccbb9c7d.svg";